// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UQ3a","col":"styles_col__2KJ8C"};